import { gql, useMutation } from '@apollo/client'
import {
  MutationUserBanStatusChangeArgs,
  MutationUserBanStatusChangePayload,
} from 'src/generated'

const MUTATION_USER_BAN_STATUS_CHANGE = gql`
  mutation UserBanStatusChange($input: MutationUserBanStatusChangeInput!) {
    userBanStatusChange(input: $input) {
      user {
        id
      }
    }
  }
`

const useUserBanStatusChangeMutation = () => {
  return useMutation<
    { userBanStatusChange: MutationUserBanStatusChangePayload },
    MutationUserBanStatusChangeArgs
  >(MUTATION_USER_BAN_STATUS_CHANGE)
}

export default useUserBanStatusChangeMutation
